import { Toggle } from "@totalenergiescode/mobility-business-rev-design-system";
import {
  Suffix,
  translateField,
  useFormData,
  useFormDataContext,
} from "@totalenergiescode/mobility-business-rev-form-data/components";

import { StyledToggleBlock } from "./styles";

interface ToggleSwitchProps {
  fieldId: string;
}

function ToggleSwitch({ fieldId }: ToggleSwitchProps) {
  const findFieldById = useFormData((fd) => fd.findFieldById);
  const { translatorFor, dataTestIdPrefix } = useFormDataContext();

  const field = findFieldById(fieldId);
  const value = field.value.asBool();
  const isChecked = value.value() || value.defaultValue();

  const writable = field.writable;

  const translator = translatorFor(field);
  const label = translateField(translator, field, Suffix.LABEL);

  const handleToggleChange = () => {
    field.setValue(!value.value());
  };

  return (
    <StyledToggleBlock>
      <Toggle
        isActive={Boolean(isChecked)}
        onChange={handleToggleChange}
        disabled={!writable}
        size={"medium"}
        key={field.id()}
        dataTestId={`${dataTestIdPrefix}-${field.id()}`}
      />
      {label.toString()}
    </StyledToggleBlock>
  );
}

export default ToggleSwitch;
